<template>
    <!-- CORE-8168: always rendered, unlike InvoiceTemplateOptions, which hides itself on an empty list. -->
    <div class="filter-inline">
        <form-group name="runSheetTemplate" label="Runsheet Template">
            <vue-select
                data-testid="runsheet-template"
                label="name"
                :options="options"
                :value="selectedOption"
                :clearable="false"
                :searchable="$root.isDesktop"
                @input="onUserSelect"
            ></vue-select>
        </form-group>
    </div>
</template>

<script>
import { handleRequests } from '@/helpers';
import { buildRunSheetTemplateOptions } from '@/utils/runSheetTemplateOptions';

export default {
    name: 'RunSheetTemplateOptions',
    props: {
        selectedRunSheetTemplateId: {
            type: [Number, Object],
            default: null
        }
    },
    data() {
        return {
            options: buildRunSheetTemplateOptions([]),
            selectedOption: null
        };
    },
    async mounted() {
        let templates = [];
        try {
            const response = await handleRequests('/api/customers/runsheet-templates');
            templates = response && response.data ? response.data : [];
        } catch (e) {
            // The selector still offers "Default"; the customer's saved binding stays in the parent's
            // customerDetails untouched, because nothing is emitted without a user action.
            templates = [];
        }
        this.options = buildRunSheetTemplateOptions(templates);
        this.selectedOption = this.findOption(this.selectedRunSheetTemplateId);
    },
    watch: {
        selectedRunSheetTemplateId(value) {
            this.selectedOption = this.findOption(value);
        }
    },
    methods: {
        findOption(id) {
            const wanted = id === undefined || id === 0 ? null : id;
            return this.options.find((x) => x.runSheetTemplateId === wanted) || this.options[0];
        },
        // Emits only on a user action. There is deliberately no watcher on selectedOption: emitting the
        // initial "Default" (for example after a failed load) would clear the binding on the next save.
        onUserSelect(option) {
            this.selectedOption = option;
            this.$emit('selectedOption', option);
        }
    }
};
</script>
